import React from "react";
import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Login from './views/Login';
import Error404 from "./views/Error404";
import Error403 from "./views/Error403";
import { ProtectedRoute } from "./utils/ProtectedRoute";
import BusinessCockpit from "./views/BusinessCockpitOverview";
import BusinessCockpitDetails from "./views/BusinessCockpitDetails";
import BusinessCockpitUpload from "./views/BusinessCockpitUpload";

function App() {
  return (
    <div className="App">
      <Router>
        <Routes>
          {/* Private Route */}
          <Route path="/" element={<Login />} />
            <Route path="/b2b"  element={<ProtectedRoute component={BusinessCockpit} />} />
            <Route path="/b2b/detail/*" element={<ProtectedRoute component={BusinessCockpitDetails} />} />
            <Route path="/b2b/upload" element={<ProtectedRoute component={BusinessCockpitUpload} />} />

          {/* Public Route for 403 */}
          <Route path="/403" element={<Error403 />} />
          
          {/* Public Route for 404 */}
          <Route path="*" element={<Error404 />} />

          <Route path="/modal_split/*" element={<BusinessCockpitDetails/>} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;

